import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconShield = props => (
  <SvgIcon {...props} viewBox="0 0 16 20.134365">
    <path d="m8-0.0001173-8 2.3574v3.1582c0 5.6495 2.7793 10.944 7.424 14.212l0.576 0.406 0.576-0.406c4.649-3.278 7.424-8.568 7.424-14.212v-3.1582l-0.717-0.2109-7.283-2.147zm0 2.0859l6 1.7676v1.6621c0 4.7305-2.255 9.1305-6.002 12.06-3.7398-2.922-5.998-7.327-5.998-12.06v-1.6621l6-1.7675zm-0.043 2.9395-2.8496 1.0078c-0.0634 0.0225-0.1074 0.0919-0.1074 0.1699v1.2891c0 2.5944 1.085 5.0174 2.893 6.4844 0.034 0.027 0.069 0.041 0.107 0.041s0.073-0.013 0.107-0.041c1.808-1.467 2.893-3.89 2.893-6.4844v-1.2891c0-0.0784-0.044-0.1469-0.107-0.1699l-2.85-1.0078c-0.0281-0.01-0.05784-0.01-0.08594 0z" />
  </SvgIcon>
);

export default IconShield;



// WEBPACK FOOTER //
// ./src/components/icons/IconShield.js